import React from 'react';
import { motion } from 'framer-motion';
import { Clock, DollarSign, Target, XCircle, CheckCircle2 } from 'lucide-react';
export function DifferentiatorSection() {
  return <section className="py-24 bg-nova-navy-dark relative border-t border-nova-navy-light/20" data-id="element-36">
      <div className="container mx-auto px-4 md:px-6" data-id="element-37">
        <div className="grid lg:grid-cols-2 gap-16 items-center max-w-6xl mx-auto" data-id="element-38">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="max-w-xl" data-id="element-39">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-40">
              ¿Por qué nosotros y no una agencia costosa?
            </h2>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-41">
              Las agencias tradicionales cobran $15,000 MXN por una web que
              tarda meses en estar lista. Nosotros nos especializamos
              exclusivamente en{' '}
              <strong className="text-white font-medium" data-id="element-42">
                Negocios Locales
              </strong>
              .
            </p>
            <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-43">
              Sabemos que usted necesita velocidad y resultados, no diseños
              abstractos. Usamos la información que ya tiene en Google e
              Instagram para crearle una sucursal digital que trabaja 24/7.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#0a1120] rounded-2xl border border-nova-navy-light/30 p-1 overflow-hidden" data-id="element-44">
            <div className="grid grid-cols-2 text-center border-b border-nova-navy-light/30" data-id="element-45">
              <div className="p-4 bg-red-500/5" data-id="element-46">
                <span className="text-red-400 font-semibold text-sm uppercase tracking-wider" data-id="element-47">
                  Otras Agencias
                </span>
              </div>
              <div className="p-4 bg-nova-gold/10 border-l border-nova-navy-light/30" data-id="element-48">
                <span className="text-nova-gold font-bold text-sm uppercase tracking-wider" data-id="element-49">
                  Nova Digital
                </span>
              </div>
            </div>

            <div className="divide-y divide-nova-navy-light/30" data-id="element-50">
              {/* Row 1 */}
              <div className="grid grid-cols-2" data-id="element-51">
                <div className="p-6 flex flex-col items-center justify-center gap-2 bg-red-500/5" data-id="element-52">
                  <DollarSign className="text-red-400/50" size={24} data-id="element-53" />
                  <span className="text-gray-400 text-sm" data-id="element-54">Inversión</span>
                  <span className="text-white font-medium" data-id="element-55">$15,000+ MXN</span>
                </div>
                <div className="p-6 flex flex-col items-center justify-center gap-2 bg-nova-gold/5 border-l border-nova-navy-light/30" data-id="element-56">
                  <DollarSign className="text-nova-gold" size={24} data-id="element-57" />
                  <span className="text-gray-400 text-sm" data-id="element-58">Inversión</span>
                  <span className="text-white font-bold" data-id="element-59">$2,900 MXN</span>
                </div>
              </div>

              {/* Row 2 */}
              <div className="grid grid-cols-2" data-id="element-60">
                <div className="p-6 flex flex-col items-center justify-center gap-2 bg-red-500/5" data-id="element-61">
                  <Clock className="text-red-400/50" size={24} data-id="element-62" />
                  <span className="text-gray-400 text-sm" data-id="element-63">
                    Tiempo de entrega
                  </span>
                  <span className="text-white font-medium" data-id="element-64">1 a 3 meses</span>
                </div>
                <div className="p-6 flex flex-col items-center justify-center gap-2 bg-nova-gold/5 border-l border-nova-navy-light/30" data-id="element-65">
                  <Clock className="text-nova-gold" size={24} data-id="element-66" />
                  <span className="text-gray-400 text-sm" data-id="element-67">
                    Tiempo de entrega
                  </span>
                  <span className="text-white font-bold" data-id="element-68">72 horas</span>
                </div>
              </div>

              {/* Row 3 */}
              <div className="grid grid-cols-2" data-id="element-69">
                <div className="p-6 flex flex-col items-center justify-center gap-2 bg-red-500/5 text-center" data-id="element-70">
                  <XCircle className="text-red-400/50" size={24} data-id="element-71" />
                  <span className="text-gray-400 text-sm" data-id="element-72">Enfoque</span>
                  <span className="text-white font-medium text-sm" data-id="element-73">
                    Diseño complejo y abstracto
                  </span>
                </div>
                <div className="p-6 flex flex-col items-center justify-center gap-2 bg-nova-gold/5 border-l border-nova-navy-light/30 text-center" data-id="element-74">
                  <Target className="text-nova-gold" size={24} data-id="element-75" />
                  <span className="text-gray-400 text-sm" data-id="element-76">Enfoque</span>
                  <span className="text-white font-bold text-sm" data-id="element-77">
                    Conversión y ventas locales
                  </span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}